import {useAuthStore} from "@/store/auth";
import {useCartStore} from "@/store/cart";
import {useRouter} from "vue-router";
import {useToast} from "vue-toast-notification";
import {reactive} from "vue";

export function useCartTools() {

    const steps = reactive([
        {id: 1, name: "КОРЗИНА"},
        {id: 2, name: "ОФОРМЛЕНИЕ ЗАКАЗА"},
        {id: 3, name: "ЗАКАЗ ОФОРМЛЕН"}
    ])

    const authStore = useAuthStore()
    const cartStore = useCartStore()

    const router = useRouter()
    const toast = useToast()

    async function addCartHandler(item, selectedCoinId) {
        console.log('addCartHandler invoked ', authStore.userId, selectedCoinId);
        if (!authStore.userId) {
            await router.push({name: 'SignInView'});
            return false;
        }
        await cartStore.addCart({
            price_list_item_id: item.id, qnt: 1, comment: '', coin_id: selectedCoinId
        });
        if(cartStore.error) {
            toast.error(cartStore.error)
            return false;
        }
        toast.success('Успешно добавлено');
        return true;
    }

    return {
        addCartHandler,
        cartSteps: steps,
    }
}
